import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { searchAgainAccounts, destroy } from './actions'

export { searchAgainAccounts, destroy }

export const createAccountSearchNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'account_search',
  text: translateFn('cmd_accounts'),
  identity: '/secure/account/search',
  permission: 'ACC_ACCOUNT_LIST',
}))

export default Loadable(() => import('./Components'))
